import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Result from './result/result';
import Survey from './survey';
import EveeChatCta from './chat/ChatCTA';
import {FeatureAppContent} from '.';
import EveeChatInputLanding from './chat/EveeChatInputLanding';
import EvMapLanding from './landing/evMapLanding';
import QuestionModal from './questions';
import {DevelopmentScreenTypes, ScreenTypes, isDevelopment} from './constants';
import {getBasename} from './utils/getBasename';
import EvAmpolAmpChargeApp from './ev-ampol-amp-charge';
import VWCelebration from './vw-celebration';

type Props = {
  content: FeatureAppContent;
};

const path = window.location.pathname;

const App: React.FC<Props> = ({content}) => {
  const {
    EV_SCREEN,
    EV_SURVEY_LANDING_URL,
    EV_SURVEY_AMPOL_AMP_CHARGE_URL,
    EV_GPS_TOUR_BRANCH,
  } = content;

  const pathname = window.location.pathname;
  const basename = getBasename(pathname);
  console.log({
    EV_SCREEN,
    EV_SURVEY_LANDING_URL,
    EV_SURVEY_AMPOL_AMP_CHARGE_URL,
    EV_GPS_TOUR_BRANCH,
    basename,
  });

  const screenComponents: Record<ScreenTypes, JSX.Element> = {
    [ScreenTypes.EV_MAP_LANDING]: <EvMapLanding />,
    [ScreenTypes.EVEE_CHAT_CTA]: <EveeChatCta />,
    [ScreenTypes.EVEE_CHAT_INPUT_LANDING]: <EveeChatInputLanding />,
    [ScreenTypes.EV_AMPOL_AMP_CHARGE]: <EvAmpolAmpChargeApp />,
    [ScreenTypes.EV_VW_70_YEAR_CELEBRATION]: (
      <VWCelebration gpsTourBranch={EV_GPS_TOUR_BRANCH} />
    ),
    [ScreenTypes.EV_SURVEY_CTA]: (
      <Router basename={basename}>
        <Switch>
          <Route exact strict path={`/`}>
            <Survey surveyLandingUrl={EV_SURVEY_LANDING_URL} />
          </Route>
          <Route exact path={`/start`}>
            <QuestionModal />
          </Route>
          <Route exact path={`/results`}>
            <Result
              discoverAmpolExperienceUrl={EV_SURVEY_AMPOL_AMP_CHARGE_URL}
            />
          </Route>
        </Switch>
      </Router>
    ),
  };

  const screenType = isDevelopment ? DevelopmentScreenTypes[path] : EV_SCREEN;
  const RootComponent = screenComponents[screenType] || <></>;

  return RootComponent;
};

export default App;
